import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';

export const TAG_LIST_FILTER_OPTION_MODEL = {
  id: null,
  name: null,
};

export const INITIAL_OPTION_MODEL = {
  filterOption: TAG_LIST_FILTER_OPTION_MODEL,
  pagination: _LIST_PAGINATION_MODEL,
};
